import {Component, ViewChild} from '@angular/core';
import {
  AuthorizationService
} from "../../../../../../shared/services/authorization-management/auhorization/authorization.service";
import {
  UserActionsService
} from "../../../../../../shared/services/authorization-management/user-actions/user-actions.service";
import {AppMessageService} from "../../../../../../shared/services/app-message/app-message.service";
import {CoreOffcanvasComponent} from "../../../../../../ui-components/core-offcanvas/core-offcanvas.component";
import {UserManagementService} from "../../../../../../shared/services/user-management/user-management.service";
import {IAuthorityGroup} from "../../../models/authority-group.interface";
import {ActionTypeEnum} from "../../../models/actionType.enum";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-role-assign-detail',
  templateUrl: './role-assign-detail.component.html',
  styleUrl: './role-assign-detail.component.scss'
})
export class RoleAssignDetailComponent {
  @ViewChild('canvas') canvas: CoreOffcanvasComponent;

  authorityGroups: IAuthorityGroup[] = [];
  filteredAuthorityGroups: IAuthorityGroup[];
  authorities: any[] = [];
  filteredAuthorities: any[];
  actions: any[] = [];
  filteredActions: any[];
  user: any = {};

  roles: { label: string; value: number; authorityGroups: any }[] = [];

  searchAuthorityGroup: string = '';
  searchAuthority: string = '';
  searchAction: string = '';
  selectedRoleItem: any;
  selectedAuthorityGroup: any;
  selectedAuthority: any;

  /*  role: any = {};
    @Input() selectedRole: any;
    @Input() selectedUser: any;
    @Input() isUserAssignedToRole: boolean;
    filteredAuthorityGroupList: any[] = [];
    searchAuthorityGroup: string = '';
    selectedAuthorityGroupItem: any;
    filteredAuthorityList: any[] = [];
    searchAuthority: string = '';
    selectedAuthorityItem: any;
    filteredActionList: any[] = [];
    searchAction: string = '';
    userRoleActions: any[] = [];
    initialActionTypeList: any[] = [];*/

  constructor(
              private readonly authorityService: AuthorizationService,
              private readonly userActionsService: UserActionsService,
              private readonly appMessageService: AppMessageService,
              private readonly userService: UserManagementService,
              private readonly translate: TranslateService,
  ) {
  }


  initialize(userId: any, roleId: any) {
    this.userService.getUserWithRoleDetails(userId).subscribe((res: any) => {
      this.user = res;
      this.roles = res.roles?.map((data: any) => {
        return {
          label: data.roleName,
          value: data.id,
          authorityGroups: data.authorityGroups || []
        };
      });

      // Seçili role'u belirle
      this.selectedRoleItem = roleId;

      // Eğer seçili role varsa onun authorityGroups listesini al
      const selectedRoleObj = this.roles.find(role => role.value === roleId);
      this.filteredAuthorityGroups = selectedRoleObj?.authorityGroups || [];

      /*  Varsayılan olarak ilk authorityGroup'u seç    this.selectedAuthorityGroup = this.filteredAuthorityGroups.length > 0 ? this.filteredAuthorityGroups[0] : null;*/

      // Seçili authorityGroup'un authorities listesini hazırla
      //this.updateAuthoritiesList();

    })
    this.canvas.openPopup();
  }


  updateAuthoritiesList() {
    if (this.selectedAuthorityGroup) {
      // Eğer bir authorityGroup seçildiyse, sadece onun altındaki authorities listelenir
      this.filteredAuthorities = this.selectedAuthorityGroup.authorities || [];
    }
    /*else {
       this.filteredAuthorities = this.filteredAuthorityGroups
        .map(group => group.authorities)
        .flat();
    }*/
  }

  onRoleChange() {
    this.selectedAuthorityGroup = null;
    this.selectedAuthority = null;
    this.authorities = [];
    this.filteredAuthorities = [];
    this.filteredActions = [];
    this.filteredAuthorityGroups = [];
    this.initialize(this.user.id, this.selectedRoleItem);

    this.updateAuthoritiesList();

  }

// Authority Group değiştiğinde, authorities listesini güncelle
  onAuthorityGroupChange(newGroupId: any) {
    const selectedGroup = this.authorityGroups.find(group => group.id === newGroupId);
    this.selectedAuthorityGroup = newGroupId;
    this.authorities = selectedGroup ? selectedGroup.authorities : [];
  }


  onRoleSelected(item: any): void {

  }

  handleAuthorityGroupSearch() {
    this.filteredAuthorityGroups = this.authorityGroups.filter(ag =>
      ag.authorityGroupName.toLowerCase().includes(this.searchAuthorityGroup.toLowerCase())
    );
  }

  handleAuthoritySearch() {
    this.filteredAuthorities = this.authorities.filter(a =>
      a.authorityName.toLowerCase().includes(this.searchAuthority.toLowerCase())
    );
  }

  handleActionSearch() {
    this.filteredActions = this.actions.filter(a =>
      a.actionName.toLowerCase().includes(this.searchAction.toLowerCase())
    );
  }

  onAuthorityGroupSelect(item: any) {
    if (this.selectedAuthorityGroup === item) {
      this.selectedAuthorityGroup = null;
    } else {
      this.selectedAuthorityGroup = item;
    }
    // Seçilen grup altındaki authorities listesini güncelle
    this.updateAuthoritiesList();
  }

  onAuthoritySelect(item: any): void {
    if (this.selectedAuthority === item) {
      this.selectedAuthority = null;
    } else {
      this.selectedAuthority = item;
      this.authorityService.getActionsWithRoleUserDetails(this.selectedRoleItem, this.user.id, item.id).subscribe((res: any) => {
        this.actions = res;
        this.filteredActions = this.actions;
      })
    }

  }

  openOffcanvas() {
    this.canvas.openPopup();
  }


  toggleActionType(action: any, actionType: string): void {
    action[actionType] = !action[actionType];
    action.authorityId = this.selectedAuthority.id;
    action.authorityGroupId = this.selectedAuthorityGroup.id;
    action.roleId = this.selectedRoleItem;
    action.actionName = action.name;
    action.actionKey = action.key;
    action.actionId = action.id;
    action.userId = this.user.id;
    this.userActionsService.create(action).subscribe(res => {
      this.appMessageService.successToast(this.translate.instant('common.success'), this.translate.instant('common.updateSuccessToastMessage'));

    })
  }

  /* ngOnChanges(changes: SimpleChanges) {
     if (changes['selectedUser'] || changes['selectedRole']) {
       this.resetSelections();
       this.getRoleList();
     }
   }

   getRoleList() {
 /!*    this.roleService.getList().pipe(
       catchError((err) => {
         this.appMessageService.errorToast('Error:', err.statusText);
         return throwError(err);
       })
     ).subscribe(res => {
       this.roleList = res;
       if (this.role && this.role.id) {
         this.selectedRole = this.roleList.find(r => r.id === this.role.id) || this.selectedRole;
       } else if (this.selectedRole && this.selectedRole.id) {
         this.selectedRole = this.roleList.find(r => r.id === this.selectedRole.id);
       }
       this.updateFilteredAuthorityGroupList();
       this.getUserRoleRelation();
     });*!/
   }

   showUserAssignDetail() {
     if (this.selectedUser && this.selectedRole) {
       this.selectedUser = this.user;
       this.getRoleList();
     } else {
       console.error('Selected user or role is undefined.');
     }
   }

   isActionTypeChanged(): boolean {
     if (this.filteredActionList.length !== this.initialActionTypeList.length) {
       return true;
     }

     return this.filteredActionList.some((action, index) => {
       const currentActionType = action.actionType;
       const initialActionType = this.initialActionTypeList[index]?.actionType;

       return currentActionType !== initialActionType;
     });
   }

   getUserRoleRelation() {
     if (this.selectedUser && this.selectedRole && this.selectedUser.id && this.selectedRole.id) {
       const userId = this.selectedUser.id;
       const roleId = this.selectedRole.id;

       this.userActionsService.getUserRoleRelation(roleId, userId).subscribe(res => {
         this.userRoleActions = res;
       });
     }
   }

   updateFilteredAuthorityGroupList(): void {
     if (this.selectedUser && this.selectedRole && this.selectedUser.id && this.selectedRole.id) {
       this.roleService.getById(this.selectedRole.id).pipe(
         catchError((err) => {
           this.appMessageService.errorToast('Error:', err.statusText);
           return throwError(err);
         })
       ).subscribe(res => {
         this.filteredAuthorityGroupList = res.authorityGroups;
         this.resetFilteredAuthorityList();
       })
     } else {
       this.filteredAuthorityGroupList = [];
       this.resetFilteredAuthorityList();
     }
   }

   updateFilteredAuthorityList() {
     if (this.selectedAuthorityGroupItem) {
       this.authorityGroupService.getById(this.selectedAuthorityGroupItem.id).pipe(
         catchError((err) => {
           this.appMessageService.errorToast('Error:', err.statusText);
           return throwError(err);
         })
       ).subscribe(res => {
         this.filteredAuthorityList = res.authorities
         this.resetFilteredActionList();
       })
     } else {
       this.filteredAuthorityList = [];
       this.resetFilteredActionList();
     }
   }

   updateFilteredActionList() {
     if (this.selectedAuthorityItem) {
       this.authorityService.getById(this.selectedAuthorityItem.id).pipe(
         catchError((err) => {
           this.appMessageService.errorToast('Error:', err.statusText);
           return throwError(err);
         })
       ).subscribe(res => {
         this.filteredActionList = res.actions;
         // Kullanıcıya özel actionType kontrol ve ekle
         this.filteredActionList.forEach(action => {
           const userAction = this.userRoleActions.find(ua => ua.action.id === action.id);
           if (userAction && userAction.permissionType) {
             action.actionType = userAction.permissionType;
           }
         });
       });
     } else {
       this.resetFilteredActionList();
     }
   }

   onRoleChange(): void {
     this.updateFilteredAuthorityGroupList();
     this.getUserRoleRelation();
   }

   onAuthorityGroupClick(authorityGroup: any): void {
     if (this.selectedAuthorityGroupItem === authorityGroup) {
       this.selectedAuthorityGroupItem = null;
       this.resetFilteredAuthorityList();
     } else {
       this.selectedAuthorityGroupItem = authorityGroup;
       this.updateFilteredAuthorityList();
     }
   }

   resetFilteredActionList() {
     this.filteredActionList = [];
   }

   resetFilteredAuthorityList() {
     this.filteredAuthorityList = [];
     this.resetFilteredActionList();
   }

   authorityClick(authority: any) {
     if (this.selectedAuthorityItem === authority) {
       this.selectedAuthorityItem = null;
       this.resetFilteredActionList();
     } else {
       this.selectedAuthorityItem = authority;
       this.updateFilteredActionList();
     }
   }

   toggleActionType(action: IAction, actionType: ActionTypeEnum): void {
 /!*    const index = action.actionType.indexOf(actionType);
     if (index === -1) {
       action.actionType.push(actionType);
     } else {
       action.actionType.splice(index, 1);
     }*!/
   }

   resetSelections() {
     this.selectedAuthorityGroupItem = null;
     this.selectedAuthorityItem = null;
     this.filteredAuthorityGroupList = [];
     this.filteredAuthorityList = [];
     this.filteredActionList = [];
   }

   save() {
     if (!this.isActionTypeChanged()) {
       console.log("No changes detected in action types. Skipping save operation.");
       return;
     }
     const selectedActions = this.filteredActionList.filter(action => action.actionType.length > 0);

     const requestData: IUserAssignDetail[] = selectedActions.map(action => ({
       user: this.selectedUser.id,
       role: this.selectedRole.id,
       authorityGroup: this.selectedAuthorityGroupItem.id,
       authority: this.selectedAuthorityItem.id,
       action: action.id,
       permissionType: action.actionType
     }));

     const assignUserData = [{
       id: this.selectedRole.id,
       userId: this.selectedUser.id
     }]

     this.userActionsService.create(requestData).subscribe(res => {
       console.log(res);
     })

     this.roleService.assignUser(assignUserData).pipe(
       catchError((err) => {
         this.appMessageService.errorToast('Error:', err.statusText);
         return throwError(err);
       })
     ).subscribe(res => {
       this.appMessageService.infoToast(
         'Success!',
         'User-Role relation successfully updated',
         2000,
         'top-right'
       );
     })
   }

   cancel() {
     this.resetSelections();
   }

   protected readonly ActionTypeEnum = ActionTypeEnum;*/
  protected readonly ActionTypeEnum = ActionTypeEnum;
}
